<sd-slider
  (imagesReadyCallback)="sliderInitCallback()"
  (resizeCallback)="sliderResizeCallback()"
  [customConfig]="quoteItemConfig"
  [context]="context"
  [size]="sizesEnum.l"
  class="{{data?.length < 2 ? 'is-solo' : ''}}"
  [items]="data"
  [brand]="brand"
  [itemTemplate]="quoteTpl"
  #slider
/>

<ng-template #quoteTpl let-quoteItem>
  <div class="c__media-wrapper" [attr.data-swiper-parallax]="-300" [attr.data-swiper-parallax-opacity]="0">
    @if (quoteItem?.image) {
      <sd-banner
        [isComponentLoading]="isLoading"
        [media]="quoteItem?.image"
        [hasAltText]="false"
        #mediaQuote
        [imgRatio]="imageRatioEnum.r1_1"
        [twicPicsAutoSize]="data.length > 1 && data.indexOf(quoteItem) > 0 ? true : twicPicsAutoSize"
      />
    }
  </div>
  <div #myContainer class="c__body">
    <sd-blockquote
      [isLoading]="isLoading"
      [brand]="brand"
      [quote]="quoteItem?.quote"
      [isEditorial]="false"
      [attr.data-swiper-parallax-opacity]="0"
      [attr.data-swiper-parallax]="!isDevice$ ? -300 : 0"
    />
  </div>
</ng-template>
